import i18n from "../../i18n";

const NOTIFICATION_NAME_TITLE = "last-notif-title";
const NOTIFICATION_NAME_MESSAGE = "last-notif-msg";
const NUMBER_OF_NOTIFICATIONS = 14; // 2 * 7 days;
const array = [...new Array(NUMBER_OF_NOTIFICATIONS)];

const getLastNotifications = params =>
  array.map((el, index) => {
    return {
      title: i18n.t(`${NOTIFICATION_NAME_TITLE}-${index + 1}`, params),
      body: i18n.t(`${NOTIFICATION_NAME_MESSAGE}-${index + 1}`, params),
    };
  });

export default getLastNotifications;
